import { Attributes } from './attributes.model';

export class Contract {

    id: number = 0
    completedStep: number = 0
    contractTypeId: number = null
    contractTypeName: string
    transactionTypeId: number = null
    transactionTypeName: string
    name: string
    reason: string
    version: number = 1
    templateId: number = null
    documentId: string = null
    isGenerated: boolean = false
    isMandatoryFilled: boolean = false
    createdByUserId: number = null
    statusId: number = 1
    statusName: string = ""
    createdByName: string
    rejectedBy: string
    aiEnabled: number = 1
    isDeleted: boolean = false
    updateCount: number = 0
    createdBy: string = ""
    createDate: Date
    updatedBy: string = ""
    updateDate: Date
    attributes: Attributes[] | { [key: string]: any }
    
    // Add dynamic properties for attributes
    [key: string]: any
}
export interface Created{
    name?: string;
}
export class Signatures {
    DonotSendCompletionMailToParticipants: boolean = true
    TemplateId: number = 0
    SigningType: number = 1
    Signatories: Signatories[]
}

export class Signatories {
    Coordinates?: Coordinates[]
    EmailId: string
    Name: string
    SignerType: number = 1
}

export class Coordinates {
    Height: number = 0
    Left: number = 0
    Width?: number = 0
    Page?: string = 'ALL'
    PageNumber?: string = ''
    SearchText?: string = ''
}

export interface HelloSignConfig {
    apiKey: string;
    clientId: string;
  }

  export interface EmSignerConfig {
    secretKey: string;
    appName: string;
    username: string;
    password: string;
  }